import * as angular from 'angular';
import { AlarmLevel, ComponentDefinition } from '../../../models';
import { ILoggerService, IEventsService } from '../../../services/index';
import { mailingEventJobUpdated, emailEventTypes, guidEmpty } from '../../../common';
import { EmailEventDTO } from '../../../models/DTO/EventEmailDTO';

class MailingEventJobsListController implements angular.IComponentController {

    items: EmailEventDTO[];
    selectedItem: EmailEventDTO;
    isLoading: boolean;
    isEditMode: boolean;
    alarmLevel = AlarmLevel;
    selectItem: any;
    events = emailEventTypes;
    loadingMessage: string;
    guidEmpty: string;

    static $inject = ['$scope', '$translate', 'eventsService', 'loggerService'];

    constructor(private _$scope: angular.IScope,
        private _$translate: angular.translate.ITranslateService,
        //private _alarmService: IalarmService,
        private _eventsService: IEventsService,
        private _loggerService: ILoggerService) {
    }

    $onInit() {
        this.guidEmpty = guidEmpty;
        this._$scope.$on(mailingEventJobUpdated, () => {
            this.refresh();
        });
        this.refresh();

    }

    refresh() {
        this.loadingMessage = 'Refreshing event based e-mails';
        this.isLoading = true;
        this._eventsService
            .getEventEmails()
            .then(data => {
                this.items = data;
            })
            .finally(() => this.isLoading = false);
    }

    trySelect(item, $event: angular.IAngularEvent) {
        this.selectItem({ item: item, event: $event });
    }

    start(item: EmailEventDTO) {
        item.status = 1;
        this.startStopUpdate(item);
    }

    stop(item: EmailEventDTO) {
        item.status = 0;
        this.startStopUpdate(item);
    }

    startStopUpdate(item: EmailEventDTO) {
        this.loadingMessage = 'Updating event based email status';
        this.isLoading = true;
        this._eventsService
            .addOrUpdateEventEmail(item)
            .then(() => {
                const status = item.status === 0 ? 'disabled' : 'enabled';
                this._loggerService.logSuccess(this._$translate.instant(`Event based e-mail successfully ${status}.`));
            })
            .catch(reason => {
                this._loggerService.logError(`Cannot save :${reason}`);
            })
            .finally(() => this.isLoading = false);
    }

    delete(actionGuid: string, listenerGuid: string) {
        this.loadingMessage = 'Deleting event based e-mail';
        this.isLoading = true;
        this._eventsService
            .deleteEventEmail(actionGuid, listenerGuid)
            .then(() => {
                this.selectedItem = null;
                this._loggerService.logSuccess(this._$translate.instant('Event based e-mail successfully deleted.'));
                return this.refresh();
            })
            .catch(reason => {
                this._loggerService.logError(`Cannot delete :${reason}`);
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}

export const wtMailingEventJobsList: ComponentDefinition = {
    componentId: 'wtMailingEventJobsList',
    controller: MailingEventJobsListController,
    template: require('./mailingEventJobsList.component.html'),
    controllerAs: 'vm',
    bindings: {
        items: '=',
        isEditMode: '=',
        selectedItem: '=',
        selectItem: '&'
    }
};